import { useQuery } from "@tanstack/react-query";
import { getWorkoutStreaks } from "../services/firebase-weight-service";
import { getGuestWorkouts } from "../services/guestStorage";

export const useWorkouts = (uid, currentMonth) => {
  const isGuest = !uid || uid === "guest";

  return useQuery({
    queryKey: [
      "workouts",
      uid,
      currentMonth.getMonth(),
      currentMonth.getFullYear(),
    ],
    queryFn: () => {
      if (isGuest) {
        // Return a Set of date strings for the month from localStorage
        const workouts = getGuestWorkouts();
        const monthStart = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
        const monthEnd = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
        const daysSet = new Set();
        workouts.forEach((w) => {
          const d = new Date(w.day);
          if (d >= monthStart && d <= monthEnd && !w.isDelete) {
            daysSet.add(d.toDateString());
          }
        });
        return daysSet;
      }
      return getWorkoutStreaks(uid, currentMonth);
    },
    enabled: true,
    initialData: new Set(),
  });
};
